<template>
  <div>
    <div class="tabs">
      <ul class="nav nav-tabs flex-row my-3 my-md-5" role="tablist">
        <li class="nav-item col auto col-md-auto p-0">
          <a v-bind:class="{ active: isActive == 1 }" @click="changeTab(1)">
            {{ I18n.t("auctions_catalogs.details") }}
          </a>
        </li>
        <li class="nav-item col auto col-md-auto p-0">
          <a v-bind:class="{ active: isActive == 2 }" @click="changeTab(2)">
            {{ I18n.t("auctions_catalogs.bidding_rules") }}
          </a>
        </li>
        <li class="nav-item col auto col-md-auto p-0">
          <a v-bind:class="{ active: isActive == 3 }" @click="changeTab(3)">
            {{ I18n.t("auctions_catalogs.contact") }}
          </a>
        </li>
      </ul>
    </div>
    <div class="tab-content">
      <div v-bind:class="{ 'active': isActive == 1 }" class="tab-pane">
        <AuctionDetails/>
      </div>
      <div v-bind:class="{ 'active': isActive == 2 }" class="tab-pane">
        <div class="row">
          <div class="col-sm-6"></div>
        </div>
      </div>
      <div v-bind:class="{ 'active': isActive == 3 }" class="tab-pane">
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import AuctionDetails from './auction_details';

  export default {
    name: 'AuctionHouseTabs',
    components: {
      AuctionDetails,
    },
    data() {
      return {
        isActive: 1,
      };
    },
    computed: mapGetters(['auctionsCatalog']),
    methods: {
      changeTab(value) {
        this.isActive = value;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/auctions_catalogs/show/components/tabs.vue?41f3ab3c